import React from "react";
const Paragraph = ({ children, className = "", variant = "default" }) => {
  const variants = {
    default: "text-custom-off-gray",
    white: "text-white",
    "off-gray": " text-custom-gray-v3",
    "off-gray-2": " text-custom-gray-v4",
    opacity: "text-custom-black text-opacity-80",
    success: "text-custom-green",
    "dark-blue": "text-custom-dark-blue",
  };
  return (
    <p
      className={`${className} !leading-normal  font-normal text-sm md:text-base ${variants[variant]}`}>
      {children || "Paragraph"}
    </p>
  );
};

export default Paragraph;
